import {initializeMediaUpload} from "./utility/media-uploader";
import {initializeFormSubmission} from "./utility/form-submission"; // Import the form submission function
// Toggle functionality for menu items
(document.querySelectorAll('.toggle-icon') as NodeListOf<HTMLElement>).forEach(function (toggleIcon) {
    toggleIcon.addEventListener('click', function (e: MouseEvent) {
        const target = e.target as HTMLElement;
        const parentMenuItem = target.closest('.menu-item') as HTMLElement;
        parentMenuItem?.classList.toggle('open'); // Add 'open' class to toggle visibility
    });
});

// DOMContentLoaded event listener
document.addEventListener('DOMContentLoaded', function () {
    let uploadButton: HTMLElement | null;

    const AmbiklySettings = {
        init: function () {

            this.handleMediaUpload();
            initializeFormSubmission(); // Call the imported form submission function
        },
        handleMediaUpload: function () {
            const uploadButtons = document.querySelectorAll('.ambikly-image-upload');
            (uploadButtons as NodeListOf<HTMLElement>).forEach((button) => {
                button.addEventListener('click', (e: MouseEvent) => {
                    e.preventDefault();
                    uploadButton = e.currentTarget as HTMLElement;
                    initializeMediaUpload(uploadButton);
                });
            });
        },
    };
    AmbiklySettings.init();
});
